import VisitsList from "./List";

export default function VisitsListIndex() {
    return <VisitsList />
}